import { useMemo } from 'react';

import { noop } from '@altirllc/shared/utils/functionalUtils';
import type { IStorage } from '@altirllc/shared/utils/storage';

import { PORTAL_FILTER_STORAGE_KEY } from '@/contexts/PortalFilterProvider/portalFilterUtils';

export const usePersistentFilter = (storage?: IStorage, collection?: string) =>
  useMemo(() => {
    if (!storage || !collection) {
      return { getCached: noop, setCached: noop };
    }

    return {
      getCached: <PValue extends unknown>(key: 'sorts' | 'filters') =>
        storage.getItem<{ [key: string]: PValue }>(key)?.[collection],

      setCached: <PValue extends unknown>(key: 'sorts' | 'filters', value: PValue) => {
        const map: Record<string, PValue> = storage.getItem(key) ?? {};

        map[collection] = value;
        storage.setItem(key, map);
      },
    };
  }, [collection, storage]);

export const clearPersistentFilters = (storage: IStorage) => {
  storage.removeItem('filters');
  storage.removeItem('sorts');
  storage.removeItem(PORTAL_FILTER_STORAGE_KEY);
};
